export const getIsInSupportedLocation = (
  country_of_tax_residence: string,
  state: string,
) => {
  const supportedCountries: string[] =
    window?.env?.SUPPORTED_CRYPTO_TRANSFER_COUNTRIES?.split(",") ?? [];

  const supportedStates: string[] =
    window?.env?.SUPPORTED_CRYPTO_STATES?.split(",") ?? [];

  if (supportedCountries.includes(country_of_tax_residence)) {
    if (country_of_tax_residence === "USA") {
      return supportedStates.includes(state);
    }
    return true;
  }

  return false;
};
